/// <amd-module name="Build/SourceProviders/Svn" />
import { Change } from "Build/Client/Contracts/Build";

import { Base } from "Build/SourceProviders/Base";
import { RepositoryTypes } from "Build/SourceProviders/Common";
import * as Resources from "Build/SourceProviders/Resources";

import { format } from "VSS/Core/Util/String";

export class Svn extends Base {
    public getKey() {
        return RepositoryTypes.Svn;
    }

    public getName() {
        return Resources.Svn;
    }

    public getRepoIconName(): string {
        return "SVNLogo";
    }

    public getChangeText(change: Change): string {
        if (change && change.id) {
            return format(Resources.CommitId, change.id.slice(0, 7));
        }
        else {
            return "";
        }
    }
}
